import { render, staticRenderFns } from "./MissionsComp.vue?vue&type=template&id=2bb99a6b&scoped=true"
import script from "./MissionsComp.vue?vue&type=script&lang=js"
export * from "./MissionsComp.vue?vue&type=script&lang=js"
import style0 from "./MissionsComp.vue?vue&type=style&index=0&id=2bb99a6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb99a6b",
  null
  
)

/* custom blocks */
import block0 from "./MissionsComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports